export const CountriesWithMandatoryStateOrProvince = [
    'United States',
    'Canada',
    'Australia'
];
